/**
 * Kayıt sürüyor mu? Renderer her değişimde `recordingWindowMode` ile haber
 * veriyor (bkz. App.tsx); hatırlatıcı ve görüşme izleyici buna bakıyor —
 * kayıt sürerken "Kaydet" uyarısı çıkmasın, görüşmenin bitişi izlensin.
 */

type Listener = (active: boolean) => void;

let active = false;
const listeners = new Set<Listener>();

export function setRecordingActive(next: boolean): void {
  if (next === active) return;
  active = next;
  for (const listener of listeners) listener(active);
}

export function isRecordingActive(): boolean {
  return active;
}

export function onRecordingStateChange(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
